import React, { useState } from "react";
import { Store, Sparkles, PartyPopper, Gem } from "lucide-react";

// Barra statistiche VERTICALE compatta (centro-destra, mobile-first): icona + numero in
// modalità compatta, etichette al tap. Discreta, non copre la cartografia né i controlli.
export default function MapStatStrip({ openBusinesses = 0, experiencesAvailable = 0, activeEvents = 0, credits = null, levelLabel = null }) {
  const [open, setOpen] = useState(false);
  const stats = [
    { icon: Store, value: openBusinesses, label: "aperte", testid: "ss-open" },
    { icon: Sparkles, value: experiencesAvailable, label: "esperienze", testid: "ss-experiences" },
    { icon: PartyPopper, value: activeEvents, label: "eventi", testid: "ss-events" },
  ];
  if (credits != null) stats.push({ icon: Gem, value: credits, label: levelLabel || "livello", testid: "ss-credits" });

  return (
    <button
      data-testid="map-stat-strip"
      onClick={() => setOpen((o) => !o)}
      aria-label="Statistiche territorio"
      className="pointer-events-auto flex flex-col gap-1 rounded-2xl bg-[#0F1016]/85 backdrop-blur-xl border border-white/10 shadow-lg p-1.5 active:scale-95 transition-transform"
    >
      {stats.map((s) => (
        <div key={s.testid} data-testid={s.testid} className="flex items-center gap-1.5 rounded-xl px-1 py-0.5">
          <span className={`h-7 w-7 rounded-lg flex items-center justify-center shrink-0 ${s.testid === "ss-credits" ? "text-[#FFD700] bg-[#FFD700]/10" : "text-[#00E676] bg-white/5"}`}>
            <s.icon className="h-[15px] w-[15px]" />
          </span>
          <span className="text-sm font-bold tabular-nums text-white min-w-[16px] text-center">{s.value}</span>
          {open && <span className="text-[11px] text-zinc-400 pr-1 whitespace-nowrap">{s.label}</span>}
        </div>
      ))}
    </button>
  );
}
